import { t } from "@/i18n-js/instance";
import { localeRoot } from "../../constants";

export const TestimonialProperties = () => (
  <div className="hidden">{t([localeRoot, "builder.testimonials.title"])}</div>
);
